import { PRIZE_STATES } from '../../constants/prizes'
import PrizeInputsPage from './PrizeInputs'
import PrizeReportPage from './PrizeReport'
import PrizeReportGeneratingPage from './PrizeReportGenerating'

const PrizeState = ({ state, selectedRound, getStates }) => {
  switch (state) {
    case PRIZE_STATES.NONE:
    case PRIZE_STATES.RESULT_CREATED:
      return <PrizeInputsPage selectedRound={selectedRound} state={state} getStates={getStates} />
    case PRIZE_STATES.RESULT_CONFIRMED:
    case PRIZE_STATES.PRIZE_CREATED:
      return <PrizeReportGeneratingPage state={state} getStates={getStates} />
    case PRIZE_STATES.REPORT_GENERATED:
    case PRIZE_STATES.USER_NOTIFIED:
      return <PrizeReportPage selectedRound={selectedRound} state={state} getStates={getStates} />
    default:
      return <></>
  }
}

export default PrizeState
